import WebSocketService from "@/ws/WebSocketService";
import { AttendanceNotification } from "@/views/monitoring/socket.js";

const MonitoringSocket = (socket) => {
    const socketService = new WebSocketService(socket);
    socketService.subscribeChannel('monitoring-channel');

    // Events... 
    AttendanceNotification(socketService);
}

export default MonitoringSocket;